var map = {
	"./0-fig_1.png": 17599,
	"./1-demand_1.png": 99788,
	"./10-Early_entry_1.png": 12671,
	"./10-Early_entry_2.png": 16205,
	"./11-Adult_education_1.png": 28478,
	"./11-Adult_education_2.png": 67356,
	"./12-Low_performance_1.png": 61867,
	"./12-Low_performance_2.png": 6253,
	"./12-Low_performance_3.png": 67755,
	"./13-spending_1.png": 33226,
	"./14-householdwealth_1.png": 34456,
	"./14-householdwealth_2.png": 832,
	"./14-householdwealth_3.png": 66381,
	"./15-taxrevenue_1.png": 86977,
	"./15-taxrevenue_2_1.png": 32837,
	"./15-taxrevenue_2_2.png": 13384,
	"./15-taxrevenue_3.png": 65897,
	"./17-studentdebt_1.png": 25560,
	"./17-studentdebt_2.png": 19993,
	"./18-climatechange.png": 7989,
	"./19-numeracyskills_1.png": 99114,
	"./19-numeracyskills_2.png": 11024,
	"./2-Teaching_outof_field_1.png": 85049,
	"./2-Teaching_outof_field_2.png": 59269,
	"./20-computationalthinking_1.png": 70424,
	"./20-computationalthinking_2.png": 44864,
	"./21-writingtools.png": 35981,
	"./22-microcredentials.png": 49930,
	"./23-firstgeneration.png": 17825,
	"./24-readingspeed_1.png": 806,
	"./24-readingspeed_2.png": 94156,
	"./25-schoolbuilding.png": 96974,
	"./26-solarenergy.png": 97150,
	"./27-onlinesearch_1.png": 62334,
	"./27-onlinesearch_2.png": 45565,
	"./28-mathanxiety.png": 76074,
	"./29-ecce_leaders.png": 63131,
	"./3-School_calendar_1.png": 38206,
	"./30-teach_leadership.png": 10424,
	"./31-peer_effects.png": 8918,
	"./32-civic_edu-1.png": 32056,
	"./32-civic_edu-2.png": 70699,
	"./33-climate_infra.png": 29223,
	"./34-NSA_scholarships.png": 30225,
	"./35-teacher_shortage.png": 96402,
	"./36-principal_salaries-1.png": 57556,
	"./36-principal_salaries-2.png": 53177,
	"./36-principal_salaries-3.png": 16632,
	"./36-principal_salaries-4.png": 15661,
	"./36-principal_salaries-5.png": 1570,
	"./37-climate_fin.png": 3205,
	"./4-Singlesex_schools_1.png": 6608,
	"./5-Infrastructure_1.png": 77639,
	"./5-Infrastructure_2.png": 93595,
	"./6-Learningnotlinear_1.png": 57979,
	"./7-Safe_schools_1.png": 39155,
	"./8-ScholarshipsSSA_1.png": 85330,
	"./9-Indigenous_1.png": 94524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80417;